module.exports = __webpack_public_path__ + "static/img/115.e1af30d.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/kittens/200525/115.jpg
// module id = vB++
// module chunks = 0